var _dec,
  _class,
  _Video,
  _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/video/index.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from 'classnames';
import { fromJS, is } from 'immutable';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { getSettings } from 'soapbox/actions/settings';
import Blurhash from 'soapbox/components/blurhash';
import Icon from 'soapbox/components/icon';
import { isPanoramic, isPortrait, minimumAspectRatio, maximumAspectRatio } from 'soapbox/utils/media_aspect_ratio';
import { isFullscreen, requestFullscreen, exitFullscreen } from '../ui/util/fullscreen';
const DEFAULT_HEIGHT = 300;
const messages = defineMessages({
  play: {
    "id": "video.play",
    "defaultMessage": "Play"
  },
  pause: {
    "id": "video.pause",
    "defaultMessage": "Pause"
  },
  mute: {
    "id": "video.mute",
    "defaultMessage": "Mute sound"
  },
  unmute: {
    "id": "video.unmute",
    "defaultMessage": "Unmute sound"
  },
  hide: {
    "id": "video.hide",
    "defaultMessage": "Hide video"
  },
  expand: {
    "id": "video.expand",
    "defaultMessage": "Expand video"
  },
  close: {
    "id": "video.close",
    "defaultMessage": "Close video"
  },
  fullscreen: {
    "id": "video.fullscreen",
    "defaultMessage": "Full screen"
  },
  exit_fullscreen: {
    "id": "video.exit_fullscreen",
    "defaultMessage": "Exit full screen"
  }
});
export const formatTime = secondsNum => {
  let hours = Math.floor(secondsNum / 3600);
  let minutes = Math.floor((secondsNum - hours * 3600) / 60);
  let seconds = secondsNum - hours * 3600 - minutes * 60;
  if (hours < 10) hours = '0' + hours;
  if (minutes < 10) minutes = '0' + minutes;
  if (seconds < 10) seconds = '0' + seconds;
  return (hours === '00' ? '' : `${hours}:`) + `${minutes}:${seconds}`;
};
export const findElementPosition = el => {
  let box;
  if (el.getBoundingClientRect && el.parentNode) {
    box = el.getBoundingClientRect();
  }
  if (!box) {
    return {
      left: 0,
      top: 0
    };
  }
  const docEl = document.documentElement;
  const body = document.body;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;
  const scrollLeft = window.pageXOffset || body.scrollLeft;
  const left = box.left + scrollLeft - clientLeft;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  const scrollTop = window.pageYOffset || body.scrollTop;
  const top = box.top + scrollTop - clientTop;
  return {
    left: Math.round(left),
    top: Math.round(top)
  };
};
export const getPointerPosition = (el, event) => {
  const position = {};
  const box = findElementPosition(el);
  const boxW = el.offsetWidth;
  const boxH = el.offsetHeight;
  const boxY = box.top;
  const boxX = box.left;
  let pageY = event.pageY;
  let pageX = event.pageX;
  if (event.changedTouches) {
    pageX = event.changedTouches[0].pageX;
    pageY = event.changedTouches[0].pageY;
  }
  position.y = Math.max(0, Math.min(1, (pageY - boxY) / boxH));
  position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));
  return position;
};
export const fileNameFromURL = str => {
  const url = new URL(str);
  const pathname = url.pathname;
  const index = pathname.lastIndexOf('/');
  return pathname.substring(index + 1);
};
const mapStateToProps = state => ({
  displayMedia: getSettings(state).get('displayMedia')
});
let Video = (_dec = connect(mapStateToProps), _dec(_class = injectIntl(_class = (_Video = class Video extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      currentTime: 0,
      duration: 0,
      volume: 0.5,
      paused: true,
      dragging: false,
      containerWidth: this.props.width,
      fullscreen: false,
      hovered: false,
      muted: false,
      revealed: this.props.visible !== undefined ? this.props.visible : this.props.displayMedia !== 'hide_all' && !this.props.sensitive || this.props.displayMedia === 'show_all'
    });
    _defineProperty(this, "setPlayerRef", c => {
      this.player = c;
      if (this.player) {
        this._setDimensions();
      }
    });
    _defineProperty(this, "setVideoRef", c => {
      this.video = c;
      if (this.video) {
        this.setState({
          volume: this.video.volume,
          muted: this.video.muted
        });
      }
    });
    _defineProperty(this, "setSeekRef", c => {
      this.seek = c;
    });
    _defineProperty(this, "setVolumeRef", c => {
      this.volume = c;
    });
    _defineProperty(this, "handleClickRoot", e => e.stopPropagation());
    _defineProperty(this, "handlePlay", () => {
      this.setState({
        paused: false
      });
    });
    _defineProperty(this, "handlePause", () => {
      this.setState({
        paused: true
      });
    });
    _defineProperty(this, "handleTimeUpdate", () => {
      this.setState({
        currentTime: Math.floor(this.video.currentTime),
        duration: Math.floor(this.video.duration)
      });
    });
    _defineProperty(this, "handleVolumeMouseDown", e => {
      document.addEventListener('mousemove', this.handleMouseVolSlide, true);
      document.addEventListener('mouseup', this.handleVolumeMouseUp, true);
      document.addEventListener('touchmove', this.handleMouseVolSlide, true);
      document.addEventListener('touchend', this.handleVolumeMouseUp, true);
      this.handleMouseVolSlide(e);
      e.preventDefault();
      e.stopPropagation();
    });
    _defineProperty(this, "handleVolumeMouseUp", () => {
      document.removeEventListener('mousemove', this.handleMouseVolSlide, true);
      document.removeEventListener('mouseup', this.handleVolumeMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseVolSlide, true);
      document.removeEventListener('touchend', this.handleVolumeMouseUp, true);
    });
    _defineProperty(this, "handleMouseVolSlide", throttle(e => {
      const {
        x
      } = getPointerPosition(this.volume, e);
      if (!isNaN(x)) {
        let slideamt = x;
        if (x > 1) {
          slideamt = 1;
        } else if (x < 0) {
          slideamt = 0;
        }
        this.video.volume = slideamt;
        this.setState({
          volume: slideamt
        });
      }
    }, 60));
    _defineProperty(this, "handleMouseDown", e => {
      document.addEventListener('mousemove', this.handleMouseMove, true);
      document.addEventListener('mouseup', this.handleMouseUp, true);
      document.addEventListener('touchmove', this.handleMouseMove, true);
      document.addEventListener('touchend', this.handleMouseUp, true);
      this.setState({
        dragging: true
      });
      this.video.pause();
      this.handleMouseMove(e);
      e.preventDefault();
      e.stopPropagation();
    });
    _defineProperty(this, "handleMouseUp", () => {
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseMove, true);
      document.removeEventListener('touchend', this.handleMouseUp, true);
      this.setState({
        dragging: false
      });
      this.video.play();
    });
    _defineProperty(this, "handleMouseMove", throttle(e => {
      const {
        x
      } = getPointerPosition(this.seek, e);
      const currentTime = Math.floor(this.video.duration * x);
      if (!isNaN(currentTime)) {
        this.video.currentTime = currentTime;
        this.setState({
          currentTime
        });
      }
    }, 60));
    _defineProperty(this, "handleVideoKeyDown", e => {
      // On the video element or the seek bar, we can safely use the space bar
      // for playback control because there are no buttons to press

      if (e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        this.togglePlay();
      }
    });
    _defineProperty(this, "handleKeyDown", e => {
      const frameTime = 1 / 25;
      switch (e.key) {
        case 'k':
          e.preventDefault();
          e.stopPropagation();
          this.togglePlay();
          break;
        case 'm':
          e.preventDefault();
          e.stopPropagation();
          this.toggleMute();
          break;
        case 'f':
          e.preventDefault();
          e.stopPropagation();
          this.toggleFullscreen();
          break;
        case 'j':
          e.preventDefault();
          e.stopPropagation();
          this.seekBy(-10);
          break;
        case 'l':
          e.preventDefault();
          e.stopPropagation();
          this.seekBy(10);
          break;
        case ',':
          e.preventDefault();
          e.stopPropagation();
          this.seekBy(-frameTime);
          break;
        case '.':
          e.preventDefault();
          e.stopPropagation();
          this.seekBy(frameTime);
          break;
      }

      // If we are in fullscreen mode, we don't want any hotkeys
      // interacting with the UI that's not visible

      if (this.state.fullscreen) {
        e.preventDefault();
        e.stopPropagation();
        if (e.key === 'Escape') {
          exitFullscreen();
        }
      }
    });
    _defineProperty(this, "togglePlay", e => {
      if (e) {
        e.stopPropagation();
      }
      if (this.state.paused) {
        this.setState({
          paused: false
        }, () => this.video.play());
      } else {
        this.setState({
          paused: true
        }, () => this.video.pause());
      }
    });
    _defineProperty(this, "toggleFullscreen", () => {
      if (isFullscreen()) {
        exitFullscreen();
      } else {
        requestFullscreen(this.player);
      }
    });
    _defineProperty(this, "handleResize", debounce(() => {
      if (this.player) {
        this._setDimensions();
      }
    }, 250, {
      trailing: true
    }));
    _defineProperty(this, "handleScroll", throttle(() => {
      if (!this.video) {
        return;
      }
      const {
        top,
        height
      } = this.video.getBoundingClientRect();
      const inView = top <= (window.innerHeight || document.documentElement.clientHeight) && top + height >= 0;
      if (!this.state.paused && !inView) {
        this.setState({
          paused: true
        }, () => this.video.pause());
      }
    }, 150, {
      trailing: true
    }));
    _defineProperty(this, "handleFullscreenChange", () => {
      this.setState({
        fullscreen: isFullscreen()
      });
    });
    _defineProperty(this, "handleMouseEnter", () => {
      this.setState({
        hovered: true
      });
    });
    _defineProperty(this, "handleMouseLeave", () => {
      this.setState({
        hovered: false
      });
    });
    _defineProperty(this, "toggleMute", () => {
      const muted = !this.video.muted;
      this.setState({
        muted
      }, () => {
        this.video.muted = muted;
      });
    });
    _defineProperty(this, "toggleReveal", e => {
      e.stopPropagation();
      if (this.props.onToggleVisibility) {
        this.props.onToggleVisibility();
      } else {
        this.setState({
          revealed: !this.state.revealed
        });
      }
    });
    _defineProperty(this, "handleLoadedData", () => {
      if (this.props.startTime) {
        this.video.currentTime = this.props.startTime;
        this.video.play();
      }
    });
    _defineProperty(this, "handleProgress", () => {
      if (this.video.buffered.length > 0) {
        this.setState({
          buffer: this.video.buffered.end(0) / this.video.duration * 100
        });
      }
    });
    _defineProperty(this, "handleVolumeChange", () => {
      this.setState({
        volume: this.video.volume,
        muted: this.video.muted
      });
    });
    _defineProperty(this, "handleOpenVideo", () => {
      const {
        src,
        preview,
        width,
        height,
        alt
      } = this.props;
      const media = fromJS({
        type: 'video',
        url: src,
        preview_url: preview,
        description: alt,
        width,
        height
      });
      this.video.pause();
      this.props.onOpenVideo(media, this.video.currentTime);
    });
    _defineProperty(this, "handleCloseVideo", () => {
      this.video.pause();
      this.props.onCloseVideo();
    });
    _defineProperty(this, "getPreload", () => {
      const {
        startTime,
        detailed
      } = this.props;
      const {
        dragging,
        fullscreen
      } = this.state;
      if (startTime || fullscreen || dragging) {
        return 'auto';
      } else if (detailed) {
        return 'metadata';
      } else {
        return 'none';
      }
    });
  }
  _setDimensions() {
    const width = this.player.offsetWidth;
    if (this.props.cacheWidth) {
      this.props.cacheWidth(width);
    }
    this.setState({
      containerWidth: width
    });
  }
  seekBy(time) {
    const currentTime = this.video.currentTime + time;
    if (!isNaN(currentTime)) {
      this.setState({
        currentTime
      }, () => {
        this.video.currentTime = currentTime;
      });
    }
  }
  componentDidMount() {
    document.addEventListener('fullscreenchange', this.handleFullscreenChange, true);
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange, true);
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange, true);
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange, true);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize, {
      passive: true
    });
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange, true);
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange, true);
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange, true);
    document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange, true);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      visible
    } = this.props;
    if (!is(visible, prevProps.visible) && visible !== undefined) {
      this.setState({
        revealed: visible
      });
    }
    if (prevState.revealed && !this.state.revealed && this.video) {
      this.video.pause();
    }
  }
  render() {
    const {
      src,
      inline,
      onOpenVideo,
      onCloseVideo,
      intl,
      alt,
      detailed,
      sensitive,
      link,
      aspectRatio,
      blurhash
    } = this.props;
    const {
      containerWidth,
      currentTime,
      duration,
      volume,
      buffer,
      dragging,
      paused,
      fullscreen,
      hovered,
      muted,
      revealed
    } = this.state;
    const progress = currentTime / duration * 100;
    const playerStyle = {};
    let {
      width,
      height
    } = this.props;
    if (inline && containerWidth) {
      width = containerWidth;
      const minSize = containerWidth / (16 / 9);
      if (isPanoramic(aspectRatio)) {
        height = Math.max(Math.floor(containerWidth / maximumAspectRatio), minSize);
      } else if (isPortrait(aspectRatio)) {
        height = Math.max(Math.floor(containerWidth / minimumAspectRatio), minSize);
      } else {
        height = Math.floor(containerWidth / aspectRatio);
      }
      playerStyle.height = height || DEFAULT_HEIGHT;
    }
    let warning;
    if (sensitive) {
      warning = /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "status.sensitive_warning",
        defaultMessage: "Sensitive content",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 525,
          columnNumber: 17
        }
      });
    } else {
      warning = /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "status.media_hidden",
        defaultMessage: "Media hidden",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 527,
          columnNumber: 17
        }
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      role: "menuitem",
      className: classNames('video-player', {
        'video-player--inactive': !revealed,
        detailed,
        'video-player--inline': inline && !fullscreen,
        fullscreen
      }),
      style: playerStyle,
      ref: this.setPlayerRef,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      onClick: this.handleClickRoot,
      onKeyDown: this.handleKeyDown,
      tabIndex: 0,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 531,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Blurhash, {
      hash: blurhash,
      className: classNames('media-gallery__preview', {
        'media-gallery__preview--hidden': revealed
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 542,
        columnNumber: 9
      }
    }), revealed && /*#__PURE__*/React.createElement("video", {
      ref: this.setVideoRef,
      src: src
      // preload={this.getPreload()}
      ,
      loop: true,
      role: "button",
      tabIndex: "0",
      "aria-label": alt,
      title: alt,
      width: width,
      height: height || DEFAULT_HEIGHT,
      volume: volume,
      onClick: this.togglePlay,
      onKeyDown: this.handleVideoKeyDown,
      onPlay: this.handlePlay,
      onPause: this.handlePause,
      onTimeUpdate: this.handleTimeUpdate,
      onLoadedData: this.handleLoadedData,
      onProgress: this.handleProgress,
      onVolumeChange: this.handleVolumeChange,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 549,
        columnNumber: 22
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: classNames('spoiler-button', {
        'spoiler-button--hidden': !sensitive || revealed
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 571,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "spoiler-button__overlay",
      onClick: this.toggleReveal,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 572,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "spoiler-button__overlay__label",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 573,
        columnNumber: 13
      }
    }, warning))), /*#__PURE__*/React.createElement("div", {
      className: classNames('video-player__controls', {
        active: paused || hovered
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 577,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "video-player__seek",
      onMouseDown: this.handleMouseDown,
      ref: this.setSeekRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 578,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "video-player__seek__buffer",
      style: {
        width: `${buffer}%`
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 579,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "video-player__seek__progress",
      style: {
        width: `${progress}%`
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 580,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: classNames('video-player__seek__handle', {
        active: dragging
      }),
      tabIndex: "0",
      style: {
        left: `${progress}%`
      },
      onKeyDown: this.handleVideoKeyDown,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 582,
        columnNumber: 13
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "video-player__buttons-bar",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 590,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "video-player__buttons left",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 591,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      title: intl.formatMessage(paused ? messages.play : messages.pause),
      "aria-label": intl.formatMessage(paused ? messages.play : messages.pause),
      className: "player-button",
      onClick: this.togglePlay,
      autoFocus: detailed,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 592,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: paused ? require('@tabler/icons/player-play.svg') : require('@tabler/icons/player-pause.svg'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 592,
        columnNumber: 251
      }
    })), /*#__PURE__*/React.createElement("button", {
      type: "button",
      title: intl.formatMessage(muted ? messages.unmute : messages.mute),
      "aria-label": intl.formatMessage(muted ? messages.unmute : messages.mute),
      className: "player-button",
      onClick: this.toggleMute,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 593,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: muted ? require('@tabler/icons/volume-3.svg') : require('@tabler/icons/volume.svg'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 593,
        columnNumber: 230
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: classNames('video-player__volume', {
        active: this.state.hovered
      }),
      onMouseDown: this.handleVolumeMouseDown,
      ref: this.setVolumeRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 595,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "video-player__volume__current",
      style: {
        width: `${volume * 100}%`
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 596,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: classNames('video-player__volume__handle'),
      tabIndex: "0",
      style: {
        left: `${volume * 100}%`
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 597,
        columnNumber: 17
      }
    })), (detailed || fullscreen) && /*#__PURE__*/React.createElement("span", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 605,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "video-player__time-current",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 606,
        columnNumber: 19
      }
    }, formatTime(currentTime)), /*#__PURE__*/React.createElement("span", {
      className: "video-player__time-sep",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 607,
        columnNumber: 19
      }
    }, "/"), /*#__PURE__*/React.createElement("span", {
      className: "video-player__time-total",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 608,
        columnNumber: 19
      }
    }, formatTime(duration))), link && /*#__PURE__*/React.createElement("span", {
      className: "video-player__link",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 612,
        columnNumber: 24
      }
    }, link)), /*#__PURE__*/React.createElement("div", {
      className: "video-player__buttons right",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 615,
        columnNumber: 13
      }
    }, sensitive && !onCloseVideo && /*#__PURE__*/React.createElement("button", {
      type: "button",
      title: intl.formatMessage(messages.hide),
      "aria-label": intl.formatMessage(messages.hide),
      className: "player-button",
      onClick: this.toggleReveal,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 616,
        columnNumber: 48
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: require('@tabler/icons/eye-off.svg'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 616,
        columnNumber: 213
      }
    })), !fullscreen && onOpenVideo && /*#__PURE__*/React.createElement("button", {
      type: "button",
      title: intl.formatMessage(messages.expand),
      "aria-label": intl.formatMessage(messages.expand),
      className: "player-button",
      onClick: this.handleOpenVideo,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 617,
        columnNumber: 48
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: require('@tabler/icons/maximize.svg'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 617,
        columnNumber: 220
      }
    })), /*#__PURE__*/React.createElement("button", {
      type: "button",
      title: intl.formatMessage(fullscreen ? messages.exit_fullscreen : messages.fullscreen),
      "aria-label": intl.formatMessage(fullscreen ? messages.exit_fullscreen : messages.fullscreen),
      className: "player-button",
      onClick: this.toggleFullscreen,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 619,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: fullscreen ? require('@tabler/icons/arrows-minimize.svg') : require('@tabler/icons/arrows-maximize.svg'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 619,
        columnNumber: 276
      }
    }))))));
  }
}, _defineProperty(_Video, "propTypes", {
  preview: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  sensitive: PropTypes.bool,
  startTime: PropTypes.number,
  onOpenVideo: PropTypes.func,
  onCloseVideo: PropTypes.func,
  detailed: PropTypes.bool,
  inline: PropTypes.bool,
  cacheWidth: PropTypes.func,
  visible: PropTypes.bool,
  onToggleVisibility: PropTypes.func,
  intl: PropTypes.object.isRequired,
  blurhash: PropTypes.string,
  link: PropTypes.node,
  aspectRatio: PropTypes.number,
  displayMedia: PropTypes.string
}), _Video)) || _class) || _class);
export { Video as default };